/* eslint-disable prefer-const */
/* eslint-disable camelcase */
import React, { useMemo, useState } from "react";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import { useAppDispatch, useAppSelector } from "store"; // keep your store hooks
import Avatar from "@mui/material/Avatar";
import { Modal } from "@mui/material";
import { update } from "lodash";
import { deleteUserChat, getUserConversationSummaryResponse, updateUserConfigResponse } from "constants/common";
import { CopySqlIcon, CopySqlIconActive, LanguageInfo, MenuAccountInfo, MenuDeleteAllChats, MenuLogout } from "assets/images/icons";
import { logoutUser } from "store/slice/authSlice";
import { setActiveChatDetails, setActiveChatId, setOutletLoading, setPromptInput, setShowInsightsOnUi, setUser } from "store/slice/userSlice";
import { useNavigate } from "react-router-dom";
import { setConversationHistory, setConversationSummary, setDisplayRecommendedOptions, setIsClarificationCurrentlyActive, toggleInsightsAgentsError } from "store/slice/conversationSlice";


function AccountInfoDrawer({ open, onClose }: { open: boolean, onClose: () => void }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { user_id, selectedDomain, name, userType, userCreated,lastPasswordUpdated } = useAppSelector((s) => s.user);
  const displayRole = userType ? userType.charAt(0).toUpperCase() + userType.slice(1) : 'User'
  const [isIpro, setIsIpro] = useState(JSON.parse(localStorage.getItem('call_ipro') || 'false'));
  const [copiedUserId, setCopiedUserId] = useState<string | null>(null);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false); // State to handle logout confirmation dialog
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false); // State to handle delete confirmation dialog
  const handleClose = () => setAnchorEl(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const formatDate = (dateString:any) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};
  const toggleMode = async () => {
    let isIpro = JSON.parse(localStorage.getItem('call_ipro') || 'false');
    isIpro = !isIpro;
    const payload: any =
    {
      username: user_id,
      domain_name: selectedDomain,
      call_conversation: JSON.parse(localStorage.getItem('convMode') || 'true'),
      call_ipro: isIpro,
      call_kb: JSON.parse(localStorage.getItem('kbMode') || 'false'),
      call_rag: JSON.parse(localStorage.getItem('ragMode') || 'false'),
      call_web_search: JSON.parse(localStorage.getItem('webSearchMode') || 'false'),
      theme: JSON.parse(localStorage.getItem('theme') || 'light'),
      language: JSON.parse(localStorage.getItem('language') || 'english'),
      update_config: true,
    }
    await updateUserConfigResponse(payload);
    localStorage.setItem('call_ipro', isIpro)
    setIsIpro(isIpro);
  }

  const handleCopyEmailId = (emailId:any) => {
      navigator.clipboard.writeText(emailId);
      setCopiedUserId(emailId);
      setTimeout(() => setCopiedUserId(null), 3000);
    };

  const handleLogout = () => {
    setOpenLogoutDialog(true);
  };

    const handleLogoutClose = () => {
    setOpenLogoutDialog(false);
  }

    const handleConfirmLogout = () => {
      setOpenLogoutDialog(false);
      const ssoLoginCheck = localStorage.getItem("sso");
  
      // dispatch logout locally first
      dispatch(logoutUser());
      dispatch(setUser(false));
  
      // if SSO, confirm and call MS logout popup
      // if (ssoLoginCheck) {
      //   Swal.fire({
      //     title: "Logout from Microsoft?",
      //     html: `<p style="font-size:14px;color:#555;margin-top:4px">You will be logged out of Microsoft SSO.</p>`,
      //     showCancelButton: true,
      //     confirmButtonText: "Yes",
      //     cancelButtonText: "No",
      //     buttonsStyling: false,
      //     customClass: {
      //       popup: "rounded-xl px-4 py-6",
      //       title: "text-lg font-semibold",
      //       htmlContainer: "text-sm text-gray-700",
      //       confirmButton: "bg-orange-400 hover:bg-orange-500 text-white px-4 py-2 rounded-md font-medium",
      //       cancelButton: "bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-md font-medium ml-2",
      //     },
      //   }).then((result) => {
      //     if (result.isConfirmed) {
      //       // safe call — use your logoutRequest if defined
      //       try {
      //         // @ts-ignore - instance type may differ — use your logout helper
      //         instance.logoutPopup?.();
      //       } catch {
      //         // fallback full redirect logout
      //         instance.logout?.();
      //       }
      //     }
      //   });
      // } else {
      //   // non-SSO: just do client-side logout, or call API if needed
      //   // e.g. navigate to login
      // }
    };


  const handleDeleteAllChats = () => {
    setOpenDeleteDialog(true);
  };

  const handleDeleteClose = () => {
    setOpenDeleteDialog(false);
  };

    const handleConfirmDelete = async () => {
      handleClose();
      setOpenDeleteDialog(false);
      dispatch(setOutletLoading(true));
      try {
        const payload: any = {
          username: user_id,
          chat_id: '',
          domain_name: selectedDomain,
          all_chats: true
        }
        const response=await deleteUserChat(payload);
      if (response.data.status) {
  
        const conversationSummaryPayload: any = {
          username: user_id,
          domain_name: selectedDomain
        }
        const summaryResponse = await getUserConversationSummaryResponse(conversationSummaryPayload);
        if (summaryResponse?.data) {
          const updatedSummary = summaryResponse.data;
          dispatch(setConversationSummary(updatedSummary));
        } else {
          dispatch(setConversationSummary([]))
        }
        console.log('in delte all chats');
        dispatch(setShowInsightsOnUi(false))
        dispatch(setActiveChatId('new'))
        dispatch(setIsClarificationCurrentlyActive(false))
        dispatch(setDisplayRecommendedOptions(false));
        navigate("/threads/new");
        dispatch(setConversationHistory([]));
        dispatch(toggleInsightsAgentsError(false));
        dispatch(setActiveChatDetails({}));
        dispatch(setPromptInput(""));
        
      }
      dispatch(setOutletLoading(false));
      } catch (error) {
        // console.log('Error deleting chat:', error);
      }
    };


  return (
    <>
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      keepMounted
      sx={{
        "& .MuiDrawer-paper": {
          width: { xs: "100vw", sm: 420, md: 420 },
          maxWidth: "48vw",
          height: "100vh",
          boxShadow: 4,
        },
      }}
    >
      {/* Container handles theme */}
      <div className="h-full flex flex-col bg-white dark:bg-[#1f1f1f] text-[#363636] dark:text-gray-100 ">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-3 shadow-md shadow-[rgba(0,0,0,0.1)] border-b border-gray-200 dark:border-[#2a2a2a]">
          <div className="text-[14px] font-semibold">
            Account Info
          </div>
          <div className="flex text-[12px] items-center gap-2">

            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>

        {/* Body */}

        <div className="bg-white px-[14px] dark:bg-[#212121]">
          {/* Profile Header */}
          <div className="w-full text-center pb-4 pt-4 ">
            <Avatar className='uppercase' sx={{ width: 80, height: 80, justifySelf: "center", bgcolor: "#F7901D", fontSize: 30 }}>
              {user_id?.slice?.(0, 1) ?? "U"}
            </Avatar>
            <h2 className="text-[12px]  font-semibold pt-4 text-gray-900">{name}</h2>
          </div>

          {/* My Profile Section */}
          <div className="bg-[#F7F3EF] dark:bg-[#2c2c2c] p-3 mb-8 rounded-lg">
            <h3 className="text-[12px] font-semibold text-[#312E2D] dark:text-gray-300 mb-3 flex items-center gap-2">
              <MenuAccountInfo/>
              My Profile
            </h3>
            <div className="overflow-x-auto ml-[16px]">
              <table className="w-full text-[12px]">
                <tbody>
                  <tr>
                    <td className="py-1 text-[#707070] dark:text-gray-400 text-left w-[40%]">
                      Email ID:
                    </td>
                    <td className="py-1 text-[#312E2D] dark:text-gray-200 text-left ">
                      {user_id}                      
                    </td>
                    <td className="">
                      <span onClick={() => handleCopyEmailId(user_id)} className="cursor-pointer absolute mt-[-8px] ml-[-16px]  items-center duration-200">
                        {copiedUserId === user_id ? <CopySqlIconActive /> : <CopySqlIcon />}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 text-[#707070] dark:text-gray-400 text-left">
                      Login Type:
                    </td>
                    <td className="py-1 text-[#312E2D] dark:text-gray-200 text-left ">
                      {displayRole === 'Sso'?displayRole?.toUpperCase():displayRole}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 text-[#707070] dark:text-gray-400 text-left">
                      Joined On:
                    </td>
                    <td className="py-1 text-[#312E2D] dark:text-gray-200 text-left ">
                      {formatDate(userCreated)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>

          {/* Language Section */}
          <div className="px-3 mb-4">
            <h3 className="text-[12px] font-semibold text-[#363636] dark:text-gray-300 flex items-center gap-2">
              <LanguageInfo />
              Language
            </h3>
            <div className="group">
            <p className="ml-[22px] text-[12px] mt-5  text-[#f7901d] font-bold">English</p>
            </div>
          </div>
          <div className="border-b border-dashed border-[#DADADA]" />

          {/* <div className="group flex flex-row-reverse items-center mb-8 mb-[20px]">
            <Avatar className='uppercase text-[15px]' sx={{ width: 28, height: 28, padding: 0, backgroundColor: "#F7901D" }}>{user_id.slice(0, 1)}</Avatar>
            <div className='mr-4 -mt-2 max-w-2xl  min-h-[40px] rounded-3xl rounded-br-none px-[18px] dark:text-[#ececec] dark:bg-[#2f2f2f] pb-[6px] pt-[10px] text-[12px] font-medium fontInsights bg-[#F1D4B3] text-[#363636]'>
              {item.content[0].question}
            </div>
            <span onClick={() => handleCopy(item)} className="cursor-pointer mr-2 mt-[-6px] items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              {copiedQues === item.message_id ? <CopySqlIconActive /> : <CopySqlIcon />}
            </span>
          </div> */}

          {/* Language Section */}
          {/* <div className="px-3 mb-4 mt-4 cursor-pointer" onClick={handleDeleteAllChats}>
            <h3  className="text-[12px] font-semibold text-[#363636] dark:text-gray-300 mb-1 flex items-center gap-2">
              <MenuDeleteAllChats />
             <p className="ml-[4px] ">Delete all chats</p>
            </h3>
          </div>
          <div className="border-b border-dashed border-[#DADADA]" /> */}

          {/* Language Section */}
          {/* <div className="px-3 mb-4 mt-4 cursor-pointer" onClick={handleLogout} >
            <h3  className="text-[12px] font-semibold mb-1 flex items-center gap-2" >
              <MenuLogout />
              <p className="ml-[4px] text-[#DB0007]  ">Logout</p>
            </h3>
          </div>
          <div className="border-b border-dashed border-[#DADADA]" /> */}

          {/* Password Section */}
          {/* <div className="px-4 mb-8">
            <h3 className=" text-[12px]  font-semibold text-gray-700 dark:text-gray-300 mb-1 flex items-center gap-2">
              <span className="material-icons  text-[12px] ">lock</span>
              Password
            </h3>
            <p className=" text-[12px]  text-[#f7901d] font-bold">XXXXXXXX</p>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              Last changed {formatDate(lastPasswordUpdated)}
            </p>
          </div>
           */}

          <div>
            {/* <Row icon={<MenuDeleteAllChats />} label="Delete all chats" onClick={handleDeleteAllChats} />
                          <div className="border-b-[0.5px] mx-[1.05rem]  border-[#CFCFCF] dark:border-gray-700" />
                          <Row icon={<MenuLogout />} label="Logout" danger onClick={handleLogout} /> */}
          </div>

          {/* Toggle Section */}
          <div className="mt-6 flex items-center justify-between  px-4 py-3 ">
            {/* <div>
              <p className="text-[12px] font-semibold text-gray-700 dark:text-gray-200">
                Flow Selection
              </p>
              <p className="text-[11px] text-gray-500 dark:text-gray-400">
                {!isIpro?'Turn on this toggle to use only the deterministic flow.':'Turn off this toggle to use the deterministic and agentic flow.'}
              </p>
            </div> */}

            {/* Fancy Toggle */}
            <div className="flex items-center justify-between mt-4">
              <span
                id="iproAgentToggleLabel"
                className="text-sm font-medium text-gray-700 dark:text-gray-300"
              />
              {/* <button
                id="iproAgentToggle"
                type="button"
                aria-labelledby="iproAgentToggleLabel"
                onClick={toggleMode}
                className={`relative inline-flex h-6 w-12 items-center rounded-full transition ${isIpro ? "bg-[#F7901D]" : "bg-gray-300 dark:bg-gray-600"
                  }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${isIpro ? "translate-x-7" : "translate-x-1"
                    }`}
                />
              </button> */}
            </div>

          </div>

        </div>


        {/* <div className="flex-1 overflow-y-auto py-4 space-y-6 overflow-x-hidden scrollbar-hover hover:scrollbar-thin scrollbar-transparent hover:scrollbar-thumb-[#F7901D] hover:scrollbar-track-[#F7901D]">
          name
        </div> */}
      </div>
    </Drawer>
    <Modal open={openDeleteDialog}>
            <div
              className="dark:bg-[#212121] bg-white absolute rounded-[10px] top-1/2 left-1/2 transform -translate-x-2/4 -translate-y-2/4 p-5 w-[376px] h-[158px] outline-none"
              data-testid="delete-chat-modal"
            >
              <div className="flex font-poppins dark:text-[#ffffff] font-semibold text-[14px] text-black mb-[25px]">
                Delete All Chat
              </div>
              <div className="fontInsights text-[12px] text-black">
                <p className="dark:text-[#ffffff]">
                  Do you really want to clear all conversations?
                </p>
              </div>
              <div className="flex justify-end gap-5 mt-[30px] font-medium">
                <button
                  type="button"
                  className=" text-[12px]  text-[#8D8D8D] h-[27px] w-[69px]"
                  onClick={handleDeleteClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="rounded-3xl text-[12px]  dark:bg-[#cf8600] bg-[#F7901D] text-[white] h-[28px] w-[68px]"
                  onClick={handleConfirmDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </Modal>
    
          <Modal open={openLogoutDialog}>
            <div
              className="dark:bg-[#212121] bg-white absolute rounded-[10px] top-1/2 left-1/2 transform -translate-x-2/4 -translate-y-2/4 p-5 w-[410px] h-[159px] outline-none"
              data-testid="delete-chat-modal"
            >
              <div className="flex font-poppins dark:text-[#ffffff] font-semibold text-[14px] text-black mb-[25px]">
                Logout
              </div>
              <div className="fontInsights text-[12px] text-black">
                <p className="dark:text-[#ffffff]">
                  Do you wish to log out of Insights Pro?
                </p>
              </div>
              <div className="flex justify-end gap-5 mt-[30px] font-medium">
                <button
                  type="button"
                  className=" text-[12px]  text-[#8D8D8D] h-[28px] w-[47px]"
                  onClick={handleLogoutClose}
                >
                  No
                </button>
                <button
                  type="button"
                  className="rounded-3xl text-[12px]  dark:bg-[#cf8600] bg-[#F7901D] text-[white] h-[28px] w-[60px]"
                  onClick={handleConfirmLogout}
                >
                  Yes
                </button>
              </div>
            </div>
          </Modal>
    </>
  );
};

export default AccountInfoDrawer;